import { ReactNode } from "react";

import Box from "ds/components/Box";
import ViewHeaderNavigation from "components/ViewHeader/Navigation";
import PageInfoHeaderWrapper from "ds/components/PageInfoHeader/Wrapper";
import PageInfoHeaderTitle from "ds/components/PageInfoHeader/Title";
import PageInfoHeaderCaption from "ds/components/PageInfoHeader/Caption";
import PageInfoHeaderActions from "ds/components/PageInfoHeader/Actions";

type ModuleSettingsPageLayoutProps = {
  title: string;
  description: string;
  actions?: ReactNode;
  navigation?: ReactNode;
  children: ReactNode;
};

const ModuleSettingsPageLayout = ({
  children,
  title,
  description,
  actions,
  navigation,
  ...rest
}: ModuleSettingsPageLayoutProps) => {
  return (
    <Box direction="column" grow="1">
      <PageInfoHeaderWrapper align="start">
        <Box direction="column">
          <PageInfoHeaderTitle title={title} />
          <PageInfoHeaderCaption caption={description} />
          {navigation && <ViewHeaderNavigation>{navigation}</ViewHeaderNavigation>}
        </Box>
        <PageInfoHeaderActions>{actions}</PageInfoHeaderActions>
      </PageInfoHeaderWrapper>
      <Box direction="column" grow="1" {...rest}>
        {children}
      </Box>
    </Box>
  );
};

export default ModuleSettingsPageLayout;
